import axios from '@axios'

export default {
    namespaced: true,
    state: {},
    getters: {},
    mutations: {},
    actions: {
        fetchStudents(ctx, queryParams) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/students', {params: queryParams })
                    .then(response => resolve(response))
                    .catch(error => reject(error))
            })
        },
        fetchStudent(ctx, { id }) {
            return new  Promise((resolve, reject) => {
                axios
                    .get(`/students/${id}`)
                    .then(response => resolve(response))
                    .catch(error => reject(error))
            })
        },
        createStudent(ctx) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/students/create')
                    .then(response => resolve(response))
                    .catch(error => reject(error))
            })
        },
        addStudent(ctx, studentData) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/students', studentData)
                    .then(response => resolve(response))
                    .catch(error => reject(error))
            })
        },
        deleteStudent(ctx, { id }) {
            return new Promise((resolve, reject) => {
                axios
                    .delete(`/students/${id}`)
                    .then(response => resolve(response))
                    .catch(error => reject(error))
            })
        },
        editStudent(ctx, { id }){
            return new Promise((resolve, reject) => {
                axios
                    .get(`/students/${id}/edit`)
                    .then(response => resolve(response))
                    .catch(error => reject(error))
            })
        },
        updateStudent(ctx, studentData) {
            return new Promise((resolve, reject) => {
                axios
                    .put(`/students/${studentData.id}`, studentData)
                    .then(response => resolve(response))
                    .catch(error => reject(error)) 
            })
        },
        downloadStudents(ctx, data)  {
            return new Promise((resolve, reject) => 
            {
              axios
                  .post('/download-students',  data,{ responseType: 'arraybuffer' })
                  .then(response => resolve(response))
                  .catch(error => reject(error))
              })
        }

    }
}